import { anexoUrlAbsoluto } from "../services/tarefas";
import { corContraste } from "./TagChip";

/**
 * Iniciais do projeto pra usar como ícone padrão (substitui emoji genérico
 * 📁/💻). Regras:
 *  - 2+ palavras: primeira letra de cada uma das duas primeiras (ex.: "Mococa
 *    em Foco" → "MF"; "em" é stopword, mas mantemos pra não complicar).
 *  - 1 palavra: primeiras 2 letras (ex.: "Sugestões" → "SU").
 *  - vazio: "?".
 * Tudo maiúsculo.
 */
export function iniciaisProjeto(nome: string | null | undefined): string {
  if (!nome) return "?";
  const partes = nome.trim().split(/\s+/).filter(Boolean);
  if (partes.length === 0) return "?";
  if (partes.length === 1) return partes[0].slice(0, 2).toUpperCase();
  return (partes[0][0] + partes[1][0]).toUpperCase();
}

type Tamanho = "xs" | "sm" | "md" | "lg";

const SIZES: Record<Tamanho, { wrap: string; img: string; text: string }> = {
  xs: { wrap: "w-5 h-5 text-[9px]",  img: "w-5 h-5",  text: "text-[9px]"  },
  sm: { wrap: "w-7 h-7 text-[11px]", img: "w-7 h-7",  text: "text-[11px]" },
  md: { wrap: "w-10 h-10 text-sm",   img: "w-10 h-10", text: "text-sm"   },
  lg: { wrap: "w-14 h-14 text-base", img: "w-14 h-14", text: "text-base" },
};

/**
 * Avatar visual de um projeto. Por padrão mostra as INICIAIS do nome num
 * círculo colorido (cor vem do tipo do projeto). Se houver `fotoUrl`, troca
 * pela imagem do projeto (mesma dimensão, recortada quadrada).
 */
export function ProjetoAvatar({
  nome,
  fotoUrl,
  cor,
  tamanho = "md",
  titulo,
  formato = "rounded-lg",
}: {
  nome: string | null | undefined;
  fotoUrl?: string | null;
  cor?: string | null;
  tamanho?: Tamanho;
  titulo?: string;
  /** Tailwind classe de border-radius (default: rounded-lg). Use rounded-full pra avatar circular. */
  formato?: string;
}) {
  const sz = SIZES[tamanho];
  if (fotoUrl) {
    return (
      <img
        src={anexoUrlAbsoluto(fotoUrl)}
        alt={nome || "projeto"}
        title={titulo || nome || undefined}
        className={`${sz.img} ${formato} object-cover shrink-0 border border-slate-200 dark:border-slate-700 bg-slate-100`}
      />
    );
  }
  const bg = cor || "#64748b";
  const txt = corContraste(bg) === "white" ? "#fff" : "#0f172a";
  return (
    <div
      className={`${sz.wrap} ${formato} flex items-center justify-center shrink-0 font-bold tracking-tight select-none`}
      style={{ background: bg, color: txt }}
      title={titulo || nome || undefined}
    >
      {iniciaisProjeto(nome)}
    </div>
  );
}
